// src/components/personal/sections/OrdersSection/utils/phoneUtils.ts
/**
 * Нормализует телефонный номер, удаляя все не цифровые символы
 * Например: +7 (701) 773-36-97 -> 77017733697
 * 
 * @param phone - Телефонный номер в любом формате
 * @returns Нормализованный номер, содержащий только цифры
 */
export const normalizePhoneNumber = (phone: string): string => {
    if (!phone) return '';
    
    // Удаляем все не цифровые символы
    return phone.replace(/\D/g, '');
  };
  
  /**
   * Проверяет, является ли строка телефонным номером
   * 
   * @param value - Проверяемая строка
   * @returns true если строка похожа на телефонный номер
   */
  export const isPhoneNumber = (value: string): boolean => {
    if (!value) return false;
    
    // Удаляем все не цифровые символы
    const digitsOnly = value.replace(/\D/g, '');
    
    // Если после удаления специальных символов осталось не менее 10 цифр,
    // то считаем, что это телефонный номер
    return digitsOnly.length >= 10;
  };
  
  /**
   * Подготавливает строку поискового запроса
   * Если строка похожа на телефонный номер, нормализует его
   * 
   * @param searchQuery - Исходная строка поискового запроса
   * @returns Подготовленная строка для поиска
   */
  export const prepareSearchQuery = (searchQuery: string): string => {
    if (!searchQuery) return '';
    
    // Проверяем, похоже ли значение на телефонный номер
    if (isPhoneNumber(searchQuery)) {
      // Если это телефон, то нормализуем его
      return normalizePhoneNumber(searchQuery);
    }
    
    // Иначе возвращаем исходное значение
    return searchQuery;
  };